// useHolidays.js
import { useEffect, useState } from "react";
import { fetchPublicHolidays, fetchSchoolHolidays } from "../services/ExternalAPIs/holidaysApi";

export function useHolidays(year, bundesland) {
  const [publicHolidays, setPublicHolidays] = useState([]);
  const [schoolHolidays, setSchoolHolidays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!bundesland || !year) return;

    let cancelled = false;
    setLoading(true);

    Promise.all([
      fetchPublicHolidays(year, bundesland.code),
      fetchSchoolHolidays(year, bundesland.apiCode),
    ])
      .then(([feiertage, ferien]) => {
        if (!cancelled) {
          setPublicHolidays(feiertage);
          setSchoolHolidays(ferien);
        }
      })
      .finally(() => !cancelled && setLoading(false));

    return () => {
      cancelled = true;
    };
  }, [year, bundesland]);

  return { publicHolidays, schoolHolidays, loading };
}
